import React from 'react'
import { useQuery } from '@apollo/client/react'
import { useIntl } from 'react-intl'
import { GenericResultHandler, GenericResultHandlerDefinition } from '../../components/responses/GenericResultHandler'
import { ShiftErrorPage } from './ShiftErrorPage'
import { CurrentShiftResponse, GET_CURRENT_SHIFT } from './ShiftQuery'
import { ViewShiftsPage } from './ViewShiftsPage'
import { useSettings } from '../Parameters'
import { messages } from './messages'

const QueryResultHandler = GenericResultHandler as GenericResultHandlerDefinition<CurrentShiftResponse>

export const ShiftsPage: React.FunctionComponent = () => {
  const currentShiftResponse = useQuery<CurrentShiftResponse>(GET_CURRENT_SHIFT, {
    fetchPolicy: 'network-only'
  })
  const { refetch } = currentShiftResponse
  const settings = useSettings()
  const { formatMessage } = useIntl()

  if (settings && settings.modules && settings.modules.shifts === false) {
    return <ShiftErrorPage message={formatMessage(messages.shiftsDisabled)} />
  }
  return (
    <QueryResultHandler queryResult={currentShiftResponse} loading unauthorized>
      {data => {
        if (data && data.currentShift.__typename === 'GetCurrentShiftSuccess') {
          return (
            <ViewShiftsPage
              currentShift={data.currentShift.currentShift}
              refetch={refetch}
            />
          )
        }
        if (data && data.currentShift.__typename === 'ShiftError') {
          return <ShiftErrorPage message={data.currentShift.error.message} />
        }
      }}
    </QueryResultHandler>
  )
}
